import { Component, OnInit, OnDestroy } from '@angular/core';
import { Project } from '../../../data/project/project';
import { ProjectAlert } from '../../../../alert/data/alert';
import { ProjectHolder } from '../../../interfaces/project-holder';
import { ProjectService } from '../../../data/project/project.service';
import { WsService } from '../../../../data/ws.service';
import { WsUpdateResponce } from '../../../../data/ws-update-responce';
import { filter, debounceTime, takeUntil } from 'rxjs/operators';
import { RxJSUnsubscribable } from 'projects/core/src/lib/core/utils/interfaces/rxjs-unsubscribable';
import { RxJSUnsubscribe } from 'projects/core/src/lib/core/utils/decorators/rxjs-unsubscribe-decorator';
import { Subject, Subscription } from 'rxjs';

@Component({
    selector: 'app-alerts-row',
    templateUrl: './alerts-row.component.html',
    styleUrls: ['./alerts-row.component.scss']
})
@RxJSUnsubscribe
export class AlertsRowComponent implements OnInit, OnDestroy, RxJSUnsubscribable {

    project: Project;
    projectAlerts: ProjectAlert[]

  wsSub1: Subscription;
  wsSub2: Subscription;
    constructor(
        protected projectHolder: ProjectHolder,
        private projectService: ProjectService,
        private wsService: WsService
    ) {
        this.project = this.projectHolder.project
    }

    ngOnInit() {
        this.getAlerts();
    this.wsSub1 = this.wsService
            .listenUntilDestroyed<WsUpdateResponce<ProjectAlert>>('/topic/update/model.notification.alert.ProjectAlert', this)
            .pipe(
                filter(updateInfo => updateInfo.entity.project.id === this.project.id),
                debounceTime(2000)
            )
            .subscribe(updateInfo => {
                this.getAlerts();
            })

    this.wsSub2 = this.wsService
            .listenUntilDestroyed<WsUpdateResponce<Project>>('/topic/update/model.project.Project', this)
            .pipe(
                filter(updateInfo => updateInfo.entity.id === this.project.id),
                filter(updateInfo => typeof updateInfo.entity.activeAlertsCount !== 'undefined'),
                debounceTime(2000)
            )
            .subscribe(updateInfo => {
                this.project.activeAlertsCount = updateInfo.entity.activeAlertsCount;
            })


    }

    getAlerts() {
        this.projectService.getProjectAlerts(this.project.id).subscribe(projectAlerts => {
            this.projectAlerts = projectAlerts
        })
    }

    ngOnDestroy() {
    if(this.wsSub1) {
      this.wsSub1.unsubscribe()
      this.wsSub1 = null;
    }

    if(this.wsSub2) {
      this.wsSub2.unsubscribe()
      this.wsSub2 = null;
    }
    }

    getUnsubFromAllSubs(): Subject<boolean> {
        return null
    }

}
